// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"36355579","732":"bd310962","977":"c6042083"}[chunkId] + ".chunk.js";
};